import type { Action } from 'redux'
import { combineReducers } from 'redux'
import { emptyObject } from 'utils'

import { FETCH_USER_SUCCESS, PATCH_USER, SET_USE_LOCAL_CURRENCY } from './constants'

interface ReducerAction extends Action {
  payload: any
}

const settings = (state = emptyObject, action: ReducerAction) => {
  switch (action.type) {
    case FETCH_USER_SUCCESS:
      return action.payload

    case PATCH_USER:
    case SET_USE_LOCAL_CURRENCY:
      return {
        ...state,
        ...action.payload,
      }

    default:
      return state
  }
}

export default combineReducers({
  settings,
})
